import React from 'react';
import { Spin } from 'antd';
import type { SpinProps } from 'antd';

export type LoadingWithCaptionProps = SpinProps & {
  /** 展示在指示器下方的说明文字（不使用已废弃的 Spin `tip`，避免与部分 antd 类型声明不一致） */
  caption: React.ReactNode;
};

/** 居中加载：antd Spin + 独立文案（不用 `tip` / `description`）。 */
export const LoadingWithCaption: React.FC<LoadingWithCaptionProps> = ({
  caption,
  children,
  ...spinProps
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
    }}
  >
    <Spin {...spinProps}>{children}</Spin>
    <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 14 }}>{caption}</span>
  </div>
);
